import { render, staticRenderFns } from "./DataDialogTable.vue?vue&type=template&id=2b0524a8&"
import script from "./DataDialogTable.vue?vue&type=script&lang=js&"
export * from "./DataDialogTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports